module.exports = __webpack_public_path__ + "static/media/panis_29.8c5e45b6.jpg";